export default __webpack_public_path__ + "4e4a65e3c1aa80bb8e6306867c13a4af.png";